<template>
    <div>

        <div class="row">
            <!-- Hazards -->
            <div class="col-md-4">
                <div class="card">
                    <div class="card-header">
                        <h4>Hazards</h4>
                    </div>
                    <div class="card-body">
                        <div class="form-inline" style="margin-bottom: 5px;">
                            <div class="form-group input-group-sm mr-2">
                                <input type="text" name="hazard_name" v-model="new_hazard.hazard_name" class="form-control" placeholder="Create New Hazard" />
                                <span v-if="errors.hazard_name" class="text-danger">
                                    <span v-for="error in errors.hazard_name">{{ error }}</span>
                                </span>
                            </div>
                            <div class="form-group input-group-sm">
                                <button class="btn btn-sm btn-success" @click="saveHazard()">Save</button>
                            </div>
                        </div>
                        <v-client-table ref="HazardsTable" :data="hazards" :columns="hazard_columns" :options="hazard_options">

                            <template slot="is_active" slot-scope="props">
                                <b-form-checkbox v-model="props.row.is_active" :value="1" @change="toggleActive('Hazard', props.row.hazard_id)" plain />
                            </template>

                        </v-client-table>
                    </div>
                </div>
            </div>
            <!-- Contributing Behavior -->
            <div class="col-md-4">
                <div class="card">
                    <div class="card-header">
                        <h4>Contributing Behavior</h4>
                    </div>
                    <div class="card-body">
                        <div class="form-inline" style="margin-bottom: 5px;">
                            <div class="form-group input-group-sm mr-2">
                                <input type="text" name="behavior_name" v-model="new_behavior.behavior_name" class="form-control" placeholder="Create New Behavior" p />
                                <span v-if="errors.behavior_name" class="text-danger">
                                    <span v-for="error in errors.behavior_name">{{ error }}</span>
                                </span>
                            </div>
                            <div class="form-group input-group-sm">
                                <button class="btn btn-sm btn-success" @click="saveBehavior()">Save</button>
                            </div>
                        </div>
                        <v-client-table ref="BehaviorsTable" :data="behaviors" :columns="behavior_columns" :options="behavior_options">

                            <template slot="is_active" slot-scope="props">
                                <b-form-checkbox v-model="props.row.is_active" :value="1" @change="toggleActive('ContributingBehavior', props.row.behavior_id)" plain />
                            </template>

                        </v-client-table>
                    </div>
                </div>
            </div>
            <!-- Contributing Conditions -->
            <div class="col-md-4">
                <div class="card">
                    <div class="card-header">
                        <h4>Contributing Conditions</h4>
                    </div>
                    <div class="card-body">
                        <div class="form-inline" style="margin-bottom: 5px;">
                            <div class="form-group input-group-sm mr-2">
                                <input type="text" name="condition_name" v-model="new_condition.condition_name" class="form-control" placeholder="Create New Condition" />
                                <span v-if="errors.condition_name" class="text-danger">
                                    <span v-for="error in errors.condition_name">{{ error }}</span>
                                </span>
                            </div>
                            <div class="form-group input-group-sm">
                                <button class="btn btn-sm btn-success" @click="saveCondition()">Save</button>
                            </div>
                        </div>
                        <v-client-table ref="ConditionsTable" :data="conditions" :columns="condition_columns" :options="condition_options">

                            <template slot="is_active" slot-scope="props">
                                <b-form-checkbox v-model="props.row.is_active" :value="1" @change="toggleActive('ContributingCondition', props.row.condition_id)" plain />
                            </template>

                        </v-client-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                hazards: [],
                behaviors: [],
                conditions: [],

                new_hazard: { is_active: 1 },
                new_behavior: { is_active: 1 },
                new_condition: { is_active: 1 },

                errors: {},

                hazard_columns: ['hazard_name', 'is_active'],
                hazard_options: {
                    headings: {
                        hazard_name: 'Name',
                        is_active: 'Active'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'hazards.hazard_name',
                    },
                    filterable: false,
                    perPage: 100000,
                    perPageValues: [],
                    sortable: ['hazard_name'],
                    columnsDropdown: false,
                    uniqueKey: 'hazard_id',
                },

                behavior_columns: ['behavior_name', 'is_active'],
                behavior_options: {
                    headings: {
                        behavior_name: 'Name',
                        is_active: 'Active'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'contributing_behaviors.behavior_name',
                    },
                    filterable: false,
                    perPage: 100000,
                    perPageValues: [],
                    sortable: ['behavior_name'],
                    columnsDropdown: false,
                    uniqueKey: 'behavior_id',
                },

                condition_columns: ['condition_name', 'is_active'],
                condition_options: {
                    headings: {
                        condition_name: 'Name',
                        is_active: 'Active'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'contributing_conditions.condition_name',
                    },
                    filterable: false,
                    perPage: 100000,
                    perPageValues: [],
                    sortable: ['condition_name'],
                    columnsDropdown: false,
                    uniqueKey: 'condition_id',
                },
            }
        },

        methods: {
            getRootCauseSettings: function() {
                //Get the data
                this.$http
                    .get('admin/root-cause-settings')
                    .then(response => {
                        //Set all the data
                        this.hazards = response.data.hazards;
                        this.behaviors = response.data.behaviors;
                        this.conditions = response.data.conditions;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },
            toggleActive: function(type, id) {
                this.$http
                .post(`admin/root-cause/${type}/${id}`)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success(response.data);
                })
                .catch(error => {
                    this.$toastr.error('Something went wrong');
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            },
            saveHazard: function() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('admin/hazard', this.new_hazard)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Hazard Saved');

                    this.hazards.push(response.data);
                    this.new_hazard = { is_active: 1 };
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            },
            saveBehavior: function() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('admin/behavior', this.new_behavior)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Behavior Saved');

                    this.behaviors.push(response.data);
                    this.new_behavior = { is_active: 1 };
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            },
            saveCondition: function() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('admin/condition', this.new_condition)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Condition Saved');

                    this.conditions.push(response.data);
                    this.new_condition = { is_active: 1 };
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the injuries
            this.getRootCauseSettings();
        }
    }
</script>
